import { render } from "./SupportTicketView.vue?vue&type=template&id=52968319&scoped=true"
import script from "./SupportTicketView.vue?vue&type=script&lang=js"
export * from "./SupportTicketView.vue?vue&type=script&lang=js"

import "./SupportTicketView.vue?vue&type=style&index=0&id=52968319&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52968319"]])

export default __exports__